module.exports = __webpack_public_path__ + "static/img/RWST_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWST_1.png
// module id = FL1Q
// module chunks = 0